import _ from 'lodash';
import getValidSubmissions from '@/containers/E4ImpactMBA/helpers/getValidSubmissions';

/**
 * Survey: PROJECT - BASELINE IMPACT
 * Question: How many employees are in managerial positions?
 * 
 * == baseline
 * question71
 * 
 * Survey: PROJECT - FINAL IMPACT
 * Question: How many employees are in managerial positions?
 * 
 * == final
 * question15
 * 
 * @param props 
 * @returns 
 */
export const numberOfHighSkillJobsCreatedPerEntrepreneurByGenderTotalCalculation = (props: any) => {
    const {filteredBaseline, filteredFinal} = getValidSubmissions(
        props.baselineSubmissions,
        props.finalSubmissions
    );
    
    return _.sumBy(filteredFinal, 'question15') - _.sumBy(filteredBaseline, 'question71');
}